<div class="design-system-snackbar">
  @if (!hasSnackbarInApp) {
    <evi-mobile-snackbar class="design-system-snackbar__snackbar"></evi-mobile-snackbar>
    <div class="design-system-snackbar__snackbar-overlay">
      Click to display a snackbar
    </div>
  }

  <div class="design-system-snackbar__section">
    <div class="design-system-snackbar__description">
      <h3>Primary snackbar</h3>
      <p>
        A simple snackbar with a primary color and a primary configuration. Default expiration and default icon
        configuration.
      </p>
    </div>

    <div class="design-system-snackbar__action">
      <button
        evi-mobile-button
        color="info"
        (click)="openPrimarySnackbar()"
      >
        Show
      </button>
    </div>
  </div>

  <div class="design-system-snackbar__section">
    <div class="design-system-snackbar__description">
      <h3>Primary snackbar with icon configuration</h3>
      <p>
        A snackbar with a primary color, a primary configuration and an icon configuration. Expires after 10 seconds.
      </p>
    </div>

    <div class="design-system-snackbar__action">
      <button
        evi-mobile-button
        color="info"
        (click)="openPrimaryFancySnackbar()"
      >
        Show
      </button>
    </div>
  </div>

  <div class="design-system-snackbar__section">
    <div class="design-system-snackbar__description">
      <h3>Info snackbar</h3>
      <p>A simple snackbar with info color, no specific configuration.</p>
    </div>

    <div class="design-system-snackbar__action">
      <button
        evi-mobile-button
        color="info"
        (click)="openInfoSnackbar()"
      >
        Show
      </button>
    </div>
  </div>

  <div class="design-system-snackbar__section">
    <div class="design-system-snackbar__description">
      <h3>Info snackbar with actions</h3>
      <p>A snackbar with info color and two actions. Expires after 15 sec.</p>
    </div>

    <div class="design-system-snackbar__action">
      <button
        evi-mobile-button
        color="info"
        (click)="openInfoFancySnackbar()"
      >
        Show
      </button>
    </div>
  </div>

  <div class="design-system-snackbar__section">
    <div class="design-system-snackbar__description">
      <h3>Success snackbar</h3>
      <p>A simple snackbar with success color, no specific configuration.</p>
    </div>

    <div class="design-system-snackbar__action">
      <button
        evi-mobile-button
        color="info"
        (click)="openSuccessSnackbar()"
      >
        Show
      </button>
    </div>
  </div>

  <div class="design-system-snackbar__section">
    <div class="design-system-snackbar__description">
      <h3>Warning snackbar</h3>
      <p>A simple snackbar with warning color, no specific configuration.</p>
    </div>

    <div class="design-system-snackbar__action">
      <button
        evi-mobile-button
        color="info"
        (click)="openWarningSnackbar()"
      >
        Show
      </button>
    </div>
  </div>

  <div class="design-system-snackbar__section">
    <div class="design-system-snackbar__description">
      <h3>Warning snackbar with action</h3>
      <p>A snackbar with warning color, one action on the left and no expiration.</p>
    </div>

    <div class="design-system-snackbar__action">
      <button
        evi-mobile-button
        color="info"
        (click)="openWarningFancySnackbar()"
      >
        Show
      </button>
    </div>
  </div>

  <div class="design-system-snackbar__section">
    <div class="design-system-snackbar__description">
      <h3>Error snackbar</h3>
      <p>A simple snackbar with error color, no specific configuration.</p>
    </div>

    <div class="design-system-snackbar__action">
      <button
        evi-mobile-button
        color="info"
        (click)="openErrorSnackbar()"
      >
        Show
      </button>
    </div>
  </div>

  <div class="design-system-snackbar__section">
    <div class="design-system-snackbar__description">
      <h3>Error snackbar with action</h3>
      <p>A snackbar with error color, one action on the right and no expiration.</p>
    </div>

    <div class="design-system-snackbar__action">
      <button
        evi-mobile-button
        color="info"
        (click)="openErrorFancySnackbar()"
      >
        Show
      </button>
    </div>
  </div>
</div>
